import { CAMPAIGN } from './mediaPlanning';
import { ApiResponse } from './types';
import { fetchData } from './utils';
import { Status } from '../../../pages/calculator/MediaPlanning/MediaPlansTable/interfaces';

export interface MediaPlan {
  campaignName: string;
  division: string;
  brand: string;
  category: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  planName: string;
  metaBooked: boolean;
  id: string;
  statuses: Status[];
}

export interface MediaPlansResponse {
  mediaPlans: MediaPlan[];
  next: string;
  total: number;
}

export const getPlansList = async (
  searchTerm: string | null,
  cursor?: string,
  limit?: string
) => {
  const params = new URLSearchParams();

  if (cursor) params.append('cursor', cursor);
  if (limit) params.append('limit', limit);
  if (searchTerm) params.append('searchTerm', searchTerm);

  const queryString = params.toString();
  const url = queryString
    ? `/${CAMPAIGN}/media-plans?${queryString}`
    : `/${CAMPAIGN}/media-plans`;

  return fetchData<ApiResponse<MediaPlansResponse>>(url);
};
